import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadComponent {
  @Output() fileUploaded = new EventEmitter();
  @Output() fileError = new EventEmitter();
  @Input() stepChange: number = 1;
  uploadError: boolean = false;
  isValidFile: boolean = false;
  errorMsg: string = '';
  fileChangedEvent: any;
  preViewImage: any = '';
  isShowEnlargeImage: boolean = false;
  FILE_TYPE: string[] = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'];
  MAX_SIZE = 5 * 1024 * 1024; // 5MB
  fileInfo = {
    name: '',
    type: ''
  };
  validFile: any;
  constructor(private cdr: ChangeDetectorRef) {}

  isFileAllowed(file: File): boolean {
    const fileExtension = this.getFileExtension(file.name);
    return this.FILE_TYPE.includes(fileExtension);
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }

  processFile = (event: any) => {
    var file = event.target.files[0];
    this.checkFile(file);
  };
  checkFile = async (file: File) => {
    if (this.isFileAllowed(file)) {
      const base64 = await this.convertBase64(file);
      if (file.type.includes('image')) {
        this.preViewImage = base64;
      } else {
        if (
          this.getFileExtension(file.name) === 'doc' ||
          this.getFileExtension(file.name) === 'docx'
        ) {
          this.fileInfo.name = file.name;
          this.fileInfo.type = 'DOC';
        } else if (this.getFileExtension(file.name) === 'pdf') {
          this.fileInfo.name = file.name;
          this.fileInfo.type = 'PDF';
        }
      }

      if (file.size > this.MAX_SIZE) {
        this.isValidFile = false;
        this.errorMsg = 'Maximum 5mb of file size.';
        this.uploadError = true;
        this.cdr.markForCheck();
        return;
      }
      this.validFile = file;
      this.isValidFile = true;
      this.cdr.markForCheck();
    } else {
      this.uploadError = true;
      this.errorMsg = 'This file type is not supported.';
    }
  };
  convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = error => {
        reject(error);
      };
    });
  };

  enlargeImage() {
    this.isShowEnlargeImage = !this.isShowEnlargeImage;
    this.cdr.markForCheck();
  }

  uploadedSuccess() {
    this.fileUploaded.emit(this.validFile);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.stepChange) {
      this.validFile = null;
      this.errorMsg = '';
      this.uploadError = false;
      this.preViewImage = '';
      this.fileInfo = { name: '', type: '' };
    }
  }

  filesDropped(files: File[]): void {
    this.checkFile(files[0]);
  }

  closeEvent() {
    this.validFile = null;
    this.isValidFile = false;
    this.preViewImage = '';
  }
}
